import Vue from 'vue'
import Vuex from 'vuex'
// import modules from './modules'
import { _isDev } from '../consts';
import { importModules } from 'vuelpers'

import createLogger from 'vuex/dist/logger'
import createPersistedState from "./plugins/persistedstate";

const modules = importModules(
  require.context(
    "./modules", false, /\.store\.(js|ts)$/
  )
)

let plugins = [
  createPersistedState({
    key: "__easy_val__",
    // paths: [
    //   // 'auth.isLoggedIn',
    //   // 'auth.currentUser.id',
    //   // 'auth.currentUser.name',
    //   // 'auth.currentUser.email',
    //   // 'auth.currentUser.role',
    // ]
  })
]
if (_isDev) plugins.push(createLogger())

Vue.use(Vuex)

const store = new Vuex.Store({
  modules, plugins,
})

export const vuexModuleNames = Object.keys(modules)

export default store
